// extracted by mini-css-extract-plugin
export var container = "_8w-0";
export var icon = "_8w-1";
export var text = "_8w-2";